var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{attrs:{"id":"roomsList"}},_vm._l((_vm.roomsList),function(roomName){return _c('option',{key:roomName},[_vm._v(" "+_vm._s(roomName)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }